// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicB2cV1SaveLeadRequest,
  TPublicB2cV1SaveLeadModel,
  IMappers,
  TPublicB2cV1SaveLeadResponse_,
  TPublicB2cV1SaveLeadResponse,
  TPublicB2cV1SaveLeadResponse_1,
  TPublicB2cV1SaveLeadResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createPublicB2cV1SaveLeadModel(parameters: TPublicB2cV1SaveLeadRequest): TPublicB2cV1SaveLeadModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'mortgage-broker-calculator',
    pathApi: '/b2c/v1/save-lead/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicB2cV1SaveLeadOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicB2cV1SaveLeadRequest;
}

export async function fetchPublicB2cV1SaveLead<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicB2cV1SaveLeadOptions<TResponse200, TResponse400>): Promise<
  TPublicB2cV1SaveLeadResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicB2cV1SaveLeadModel(parameters),
    config,
  )) as FetchResponse<TPublicB2cV1SaveLeadResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicB2cV1SaveLeadResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TPublicB2cV1SaveLeadResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TPublicB2cV1SaveLeadResponse;
}
